import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CreateTempAPIKeyRequest')
export class CreateTempAPIKeyRequest {
  @JsonProperty('desc')
  public desc = '';

  constructor(partial?: Partial<CreateTempAPIKeyRequest>) {
    Object.assign(this, partial);
  }
}

@JsonObject('CreateTempAPIKeyResponse')
export class CreateTempAPIKeyResponse {
  @JsonProperty('desc')
  public desc = '';

  @JsonProperty('key')
  public key = '';

  constructor(partial?: Partial<CreateTempAPIKeyResponse>) {
    Object.assign(this, partial);
  }
}
